import { assertNotEmpty } from '@festina-life/core'
import cx from 'classnames'

import { useTemplateContext } from '../../context/templateContext'
import type { TemplateReference } from '../../types/templateModel'
import { InheritableSelectEditor } from '../inheritableSelectEditor/InheritableSelectEditor'
import { TemplateParentLink } from '../templateParentLink/TemplateParentLink'
import { TemplateReferenceFieldValueWithError } from '../templateReference/TemplateReferenceFieldValueWithError'

type Props = {
  value: TemplateReference
}

export const TemplateReferenceDiff = ({ value }: Props) => {
  const { templateVersion, isMappingsTemplate } = useTemplateContext()

  assertNotEmpty(templateVersion)

  return (
    <div
      className={cx(
        'grid gap-x-2 items-center',
        isMappingsTemplate ? 'grid-cols-2' : 'grid-cols-4',
      )}
    >
      {isMappingsTemplate ? (
        <>
          <InheritableSelectEditor
            value={value.key}
            fromOrigin={value.origin}
            isEditable={false}
            path={value.path}
          />
          {value.source ? (
            <TemplateParentLink templateId={value.source} />
          ) : (
            '-'
          )}
        </>
      ) : (
        <>
          {value.source ? (
            <TemplateParentLink templateId={value.source} />
          ) : (
            '-'
          )}
          <TemplateReferenceFieldValueWithError
            data={value}
            fieldName="defaultSelected"
          />
          <TemplateReferenceFieldValueWithError
            data={value}
            fieldName="selectable"
          />
          <TemplateReferenceFieldValueWithError
            data={value}
            fieldName="cardinality"
          />
        </>
      )}
    </div>
  )
}
